import { useRouter } from "next/router";

import FaButton from "@/components/shared/faButton";
import { useFaButton } from "@/hooks/common/useFaButton";

type Props = {
  autoHidden: boolean;
};

/* 依頼者側の「募集・見積」FAボタン */
const OwnerAddTaskButton: React.FC<Props> = ({ autoHidden }) => {
  const { btnHidden } = useFaButton(autoHidden);
  const router = useRouter();
  const btnText = "募集･見積";

  return (
    <>
      <FaButton
        iconType="ownerAddTask"
        colorType="pink"
        value={btnText}
        clickHandler={() => router.push("/owner/task/register")}
        isAnime
        isAutoHidden={btnHidden}
      />
    </>
  );
};
export default OwnerAddTaskButton;
